module.exports = __webpack_public_path__ + "static/img/6.9fa19aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/6.png
// module id = im4N
// module chunks = 0